export default function ({ route, redirect }) {
  if (route.path.startsWith('/en')) {
    const newPath = route.path.replace(/^\/en/, '') || '/'
    return redirect(newPath)
  }
}
